import React from 'react'
import ContactUs from '../component/contact-us'
import Layout from '../component/layout'
import Faqs from '../component/coursetemplate/faq'
import NextSeoModule from '../component/next-seo';
import BreadcumbSection from '@/component/breadcumb-section'
export default function Contact() {

  return (
    <>
     <NextSeoModule
            title="Contact - learnsoft.org"
            description="learnsoft in Chennai and Provided Software Training"
            url="contact"
            img="/contact-img/quick-enquiry-form/quick-enquiry-img"
            breadcrumbs={"Contactus"}
          />
          {/* navbarBorderBottomColor="#ffffff" */}
    <Layout  navbarBackgroundColor="#281E1E">
    <BreadcumbSection pageTitle={"Contactus"}/>
<ContactUs/>
</Layout>
</>
)}
